
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Distal_Radius_Fractures_Lidstrom_Scale',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/Distal_Radius_Fractures_Lidstrom_Scale.vue